import { Skeleton } from '@nest/uikit-react';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';

export default function ConsignmentNotesPackedNotInContainerListPage() {
	const client = useTerminalClient();
	const navigate = useNavigate();
	const carrierId = useNumberParam('carrierId');

	const carrierQuery = useQuery({
		queryKey: ['carrier', carrierId],
		queryFn: () => client.carriers.getById.execute({ id: carrierId! }),
		enabled: !!carrierId
	});

	const listQuery = useInfiniteQuery({
		queryKey: ['packed-not-in-container', carrierId],
		queryFn: ({ pageParam }) => client.consignmentNotes.getPackedPackageUnitsWithoutContainerQuery.execute({ offset: pageParam, limit: 10, carrierId: carrierId! }),
		getNextPageParam: (lastPage, allPages) => (lastPage.length === 10 ? allPages.length * 10 : undefined),
		initialPageParam: 0,
		enabled: !!carrierQuery.data
	});

	const list = useMemo(() => listQuery.data?.pages.flatMap(p => p) ?? [], [listQuery.data]);

	return (
		<TerminalScreen showBackButton topBar={<div>{carrierQuery.data?.name} – zabalené mimo kontejnery</div>}>
			<div className="p-2 flex flex-col gap-2">
				{carrierQuery.isLoading || listQuery.isLoading ? (
					<div className="space-y-2">
						<Skeleton className="h-10 w-full" />
						<Skeleton className="h-10 w-full" />
					</div>
				) : (
					<>
						{list.map(item => (
							<button
								key={item.packageUnitId}
								className="w-full text-left border rounded p-2 hover:bg-muted/50"
								onClick={() => navigate(`/consignment-notes/carriers/${carrierId}/packed-not-in-container/${item.packageUnitId}`)}
							>
								<div className="font-medium">{item.parcelNumber ?? item.consignmentNumber ?? '-'}</div>
								<div className="text-muted-foreground"> {item.recipientName ?? ''}</div>
								<div>{item.packedAt ? `Zabalen: ${new Date(item.packedAt).toLocaleString()}` : ''}</div>
							</button>
						))}
						{list.length === 0 && <div className="p-6 text-center text-muted-foreground">Žádné záznamy</div>}
					</>
				)}
			</div>
		</TerminalScreen>
	);
}
